import { render, staticRenderFns } from "./address-sucess.vue?vue&type=template&id=f234f692&scoped=true"
import script from "./address-sucess.vue?vue&type=script&lang=ts"
export * from "./address-sucess.vue?vue&type=script&lang=ts"
import style0 from "./address-sucess.vue?vue&type=style&index=0&id=f234f692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f234f692",
  null
  
)

export default component.exports